<template>
  <div>
    <top-header></top-header>
    <b-container class="mt-5" style="margin-top:30px">
      <b-row>
        <b-col class="px-3 text-left">
          <div class="heading">Shipping Policy</div>
        </b-col>
      </b-row>
    </b-container>
    <div class="about-team py-3">
          
      <b-container class="mb-3 text-left">      
        
        <p class="text-justify"><b>Our delivery process</b><p>
        <p class="text-justify">Once our system processes your order, the order is passed on to the seller for packaging and delivery.</p>
        <p class="text-justify">The seller is expected to do a quality check prior to packaging the order for dispatch.</p>
        <p class="text-justify">The seller’s Delivery partner will pick the order for delivery to your address. </p>
        <p class="text-justify"><b>What are the  locations to which we can ship the products?</b></p>

        <p class="text-justify">Our sellers ship products across India. You can check the availability of products at your Pin code  while placing an order.</p>
        <p class="text-justify"><b>My order has been shipped. Now how can I track it?</b></p>
        <p class="text-justify">Once your order has been dispatched, you will receive an email and/or sms with the details of the tracking number and the courier company that is  delivering your order.</p>
        <p class="text-justify">You can track the status of your package 24 hours after your order is dispatched from our warehouse.</p>
        <p class="text-justify"><b>What is the estimated dispatch  time?</b></p>

        <p class="text-justify">As per our arrangement, our Sellers dispatch the  orders within 1-4 business days (excluding Sundays and public holidays)</p>
        <p class="text-justify"><b>Will my order be shipped as single order or there may be multiple shipment?</b></p>
        <p class="text-justify">As your order may have merchandise from different sellers the shipment may come separately from each seller. Alluraa has hundreds of sellers to ensure that you are provided with the best products from the best sellers.</p>

        <p class="text-justify"><b>Are there any shipping charges applicable on my order?</b></p>
        <p class="text-justify">We have standard shipping charges for most addresses.</p>
        <p class="text-justify">India shipping charges - A flat Rs.45 charge is applied to all orders below Rs.500, while there is free shipping for all orders above order value of Rs. 500.</p>
      </b-container>
    </div>
    <bottom-footer></bottom-footer>
    <b-modal id="modal-status" hide-footer>
      <template v-slot:modal-title>
        Status
      </template>
      <div class="d-block text-center">
        <h5>{{modal.msg}}</h5>
      </div>
      <b-link class="mt-3 button btn-solid float-right" @click="$bvModal.hide('modal-status')">Close Me</b-link>
    </b-modal>
  </div>
</template>

<script>

import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "Home",
  components: {
    "top-header": Header,
    "bottom-footer": Footer,
  },
  beforeCreate: function() {
      document.body.className = 'promo';
  },
  mounted(){
		this.init();
	},
  data() {
    return {
      form_alert: [],
      terms_condition: 'not_accepted',
      modal: {
        msg: ''
      },
      TYPE_SELLER: 'seller',
      TYPE_ADVICER: 'sales-advisor',
      customer:{
        prefix: 'mr',
        role: 'seller',
        fullname: '',
        mobile: '',
        email: '',
        location: '',
        workarea: ""
      },
      team:[
        {id:1, img:'', text:'Alluraa is an attempt to make e-commerce more inclusive, progressive, and impactful for everyone and look towards newer avenues for business growth and opportunities that enable people from every stratum to earn an earnest livelihood.'},
        {id:2, img:'', text:'E-commerce today is paving the way for businesses and retailers, but it also has the scope to uplift the ordinary people who dream of having their businesses but lack the investment. Alluraa is a way to realize that dream, to enable the common man by leveraging technology and innovation.'}
      ],
      states: ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Andaman and Nicobar Islands','Chandigarh','Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry'],
      workarea_salesadvisor: ['Self Employed','Sales & Marketing','Advertising','Logistics','Hospitality','Financial Service','Other'],
      workarea_seller: ['Cosmetics','Electronics','Fashion','Herbal Products','Organic Food','Toys & baby','Other'],
      workarea_options: [],
      mainProps: { blank: true, blankColor: '#b7b7b7', width: 400, height: 110, fluidGrow: true, class: 'm1' },
      iconImg: { width: 100, height: 100, fluidGrow: true, class: 'icon' },
      socialImg: { blank: true, blankColor: '#b7b7b7', width: 300, height: 300, fluidGrow: true, class: 'm1' },
      swiperOption: {
        direction: 'horizontal',
        initialSlide: 0,
        slidesPerGroup: 1,
        loop: false,
        watchSlidesVisibility: true,
        loopFillGroupWithBlank: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            960: {
                slidesPerView: 2,
                spaceBetween: 50
            },
            1124: {
                slidesPerView: 2,
                spaceBetween: 150
            }
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        on: {
            init: function () {
                console.log('swiper initialized');
            },
            slideChange: function() {
                console.log('slide changed');
            }
        },
        fadeEffect: {
            crossFade: true
        },
      }
    }
  },
  methods: {
    init(){
      var self = this;
      if(self.$route.params.param_role){
        self.customer.role = self.$route.params.param_role;
        self.$root.role = self.$route.params.param_role;
      //  self.customer.workarea = self['workarea_'+self.$route.params.param_role];
      }
      
      //alert(self.customer.role.replace('-',''));
      self.workarea_options = self['workarea_'+self.customer.role.replace('-','')];
      //self.customer.workarea = 
      //alert(self['workarea_'+self.customer.role]);
    },
    validateemail(email){
      var atposition=email.indexOf("@");  
      var dotposition=email.lastIndexOf(".");  
      if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){ 
        return false;  
      }else{
        return true;
      }
    },
    submitRegistration(){
      var self = this;
      var valid = true;
      self.form_alert = [];
      if(self.customer.fullname == ''){
        //self.form_alert.push("Full name is required!");
        valid = false;
      }
      if(self.customer.email == '' && self.customer.mobile == '' ){
        //self.form_alert.push("Email or mobile is required!");
        valid = false;
      }
      if(self.terms_condition == 'not_accepted'){
        //self.modal.msg = "Please accept terms and condition!";
        //self.$bvModal.show('modal-status');
        self.form_alert.push("Terms and condition is required!");
        valid = false;
        //return;
      }
      var mobile = self.customer.mobile;
      if(mobile.length < 10){
        self.form_alert.push('Please add a valid mobile number!');
        valid = false;
      }
      if(self.customer.workarea == ''){
        valid = false;
      }
      
      if(!self.validateemail(self.customer.email)){
        self.form_alert.push('Please add a valid email!');
        self.form_alert.push('All fields are mandatory!');
        valid = false;
      }else{
        console.log('Valid email format!');
      }

      if(valid == false){
        return;
      }

      var workarea = '';
      if(self.customer.workarea == 'Other'){
        workarea = self.customer.other;
      }else{
        workarea = self.customer.workarea;
      }
      
			self.axios.post(self.$root.WEBURL+'registration', {
        prefix: self.customer.prefix,
        fullname: self.customer.fullname,
        email: self.customer.email,
        mobile: self.customer.mobile,
        role: self.customer.role,
        location: self.customer.location,
        workarea: workarea
			})
			.then(function (response) {
        
				if(response.data.error == 0 || response.data.error == '0'){
          if(self.customer.role == self.TYPE_SELLER){
            self.modal.msg = "Thanks for successfully registering your profile as a seller!";
          }else{
            self.modal.msg = "Thanks for successfully registering your profile as a sales advisor!";
          }
          
          self.customer = {
            prefix: 'mr',
            role: self.TYPE_SELLER,
            fullname: '',
            mobile: '',
            email: '',
            workarea: '',
            location: '',
            other: ''
          };
          self.$bvModal.show('modal-status');
				}else if(response.data.error == 1){
          self.modal.msg = "Registration Failed! Try agin later!";
					self.$bvModal.show('modal-status');
				}else if(response.data.error == 2){
          self.modal.msg = "Registration Failed! Email or mobile allready exist!";
					self.$bvModal.show('modal-status');
				}
			})
			.catch(function (error) {
				alert(error);
			});
    }
  },
  metaInfo() {
		return{
			title: 'Shipping Policy | Alluraa',
			titleTemplate: null,
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'alluraa' },
				{ name: 'description', content: 'alluraa' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
	}
};
</script>
